export default __webpack_public_path__ + "static/media/mobileMenuBtn.faf9949a.svg";